import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";

// UI Components
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import paginationFactory from "react-bootstrap-table2-paginator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faDownload, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { toastr } from "react-redux-toastr";
import { Row, Col, Button, Container, Card, CardBody, Alert } from "reactstrap";
import xlsx from "node-xlsx";

// State
import {
  getWhitelist,
  selectWhitelist,
  createWhitelist,
  updateWhitelist,
  deleteWhitelist,
} from "../../../state/actions/adminActions";

// Custom Components
import { Group, log } from "../../../utils/logger";
import Loader from "../../../components/Loader";
import Header from "./Header";
import whitelist_table_schema from "./whitelistTableSchema";
import WhitelistModal from "./Modal.WhitelistRecord";
import { isEmpty } from "lodash";

class Whitelist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search_text: "",
      search_click_text: "",
      // Modal
      modal: {
        type: "add",
        isOpen: false,
        applyChanges: null,
      },
    };

    this.LoggerGroup = new Group("Whitelist", { disable: true });

    this.toggleModal = this.toggleModal.bind(this);
    this.onUserAction = this.onUserAction.bind(this);
    this.onSearchWhitelist = this.onSearchWhitelist.bind(this);
    this.fetchDisplayList = this.fetchDisplayList.bind(this);
  }

  componentDidMount() {
    this.LoggerGroup.emit("Mounted").end();
    this.props.getWhitelist();
  }

  onSearchWhitelist({ target }) {
    this.LoggerGroup.emit("Searching value", target.name, target.value);

    this.setState({ search_text: target.value });
  }

  fetchDisplayList(search_click_text, whitelist) {
    const search_text_regex = new RegExp(search_click_text, "i");
    const filtered_whitelist = !isEmpty(search_click_text)
      ? whitelist.filter(
          (whitelist_record) =>
            search_text_regex.test(whitelist_record.description_vch) ||
            search_text_regex.test(whitelist_record.contact_vch)
        )
      : whitelist;
    return filtered_whitelist;
  }

  onUserAction(type, whitelist) {
    this.LoggerGroup.emit("User Action triggered", { dir: whitelist });

    switch (type) {
      case "add":
        this.LoggerGroup.emit(`  [i] Adding Record to whitelist`);
        this.props.selectWhitelist({});
        this.toggleModal(true, this.props.createWhitelist);
        break;

      case "edit":
        this.LoggerGroup.emit(`  [i] Editing Record`);
        this.props.selectWhitelist(whitelist);
        this.toggleModal(true, this.props.updateWhitelist);
        break;

      case "delete":
        this.props.selectWhitelist(whitelist);
        this.LoggerGroup.emit(`  [i] Deleting Record`);
        toastr.confirm("Are you sure you want to remove this user from the whitelist?", {
          okText: "Delete Record",
          onCancel: () => this.LoggerGroup.emit(`Cancelled delete approver[${whitelist._id}]`),
          onOk: () => this.props.deleteWhitelist(whitelist),
        });
        break;
      case "search":
        this.setState({ search_click_text: this.state.search_text });
        this.props.getWhitelist(true);
        break;

      default:
        return this.LoggerGroup.emit({ error: `Invalid user action type[${type}]` });
    }

    this.LoggerGroup.end();
  }

  toggleModal(show, applyChanges) {
    const { modal } = this.state;
    modal.isOpen = typeof show === "boolean" ? show : !modal.isOpen;
    modal.applyChanges = applyChanges;

    this.setState({ modal });
  }

  render() {
    const { loading, whitelist, selected, internal_user } = this.props;
    const { onUserAction } = this;
    const { search_text, search_click_text, modal } = this.state;
    if (loading) {
      return <Loader />;
    }

    // Add key to each record for table
    whitelist.forEach((record) => (record._id = `${record.channel_vch}_${record.contact_vch}`));
    const filtered_whitelist = this.fetchDisplayList(search_click_text, whitelist);

    const AddWhitelistRecord = (props) => (
      <Row className={classNames("mb-4", props.className)}>
        <Col className="text-right">
          <Button color="primary" onClick={() => onUserAction("add")}>
            <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
            Add Record to Whitelist
          </Button>
        </Col>
      </Row>
    );

    const onDownload = () => {
      log("Executing download");

      const name = `Whitelist${search_text ? " " + search_text : ""}`;
      const options = { "!cols": [{ wch: 20 }, { wch: 10 }, { wch: 30 }] };
      const headers = ["Description", "Type", "Contact"];
      const whitelist = filtered_whitelist
        .sort((a, b) => {
          if (a.channel_vch < b.channel_vch) {
            return -1;
          }
          if (a.channel_vch > b.channel_vch) {
            return 1;
          }
          return (a.description_vch || "a").toLowerCase() >
            (b.description_vch || "a ").toLowerCase()
            ? 1
            : -1;
        })
        .map(({ description_vch, channel_vch, contact_vch }) => [
          description_vch || "",
          channel_vch,
          contact_vch,
        ]);
      const buffer = xlsx.build([{ name: name, data: [headers, ...whitelist] }], options);

      const blob = new Blob([buffer]);
      const fileName = `${name}.xlsx`;
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        // Browsers that support HTML5 download attribute
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    };

    return (
      <Container fluid className="p-0">
        <Header
          searchText={this.state.search_text}
          onSearchWhitelist={this.onSearchWhitelist}
          onSearchClick={() => onUserAction("search")}
        />

        {modal.isOpen && (
          <WhitelistModal {...modal} toggleModal={this.toggleModal} selected={selected} />
        )}

        <AddWhitelistRecord />

        <Card>
          <CardBody>
            <p>
              In the QA environment, only records listed in the table below will receive messages
              from campaign messages.
            </p>

            <p>
              <strong>Note:</strong> this will NOT prevent seed or approver messages.
            </p>

            {internal_user ? (
              <Alert color="warning" className="alert-outline">
                <div className="alert-icon">
                  <FontAwesomeIcon icon={faBell} size="lg" className="align-middle" />
                </div>

                <div
                  className="alert-message"
                  style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                >
                  <h4 className="alert-heading">Internal user</h4>
                  Because you are an internal user, whitelist records belonging to the Message
                  Broadcast/MB Organizations are included in the list below.
                  <br />
                  These will <strong>NOT</strong> be shown to external users (like this message)
                </div>
              </Alert>
            ) : null}
          </CardBody>

          <CardBody>
            <Row className="mb-2">
              <Col className="text-right">
                <Button
                  outline
                  color="primary"
                  onClick={onDownload}
                  disabled={!filtered_whitelist.length || loading.counts}
                >
                  <FontAwesomeIcon icon={faDownload} className="mr-2" />
                  Download
                </Button>
              </Col>
            </Row>

            <BootstrapTable
              bootstrap4
              hover
              classes="table-responsive-md"
              keyField="_id"
              data={filtered_whitelist}
              columns={whitelist_table_schema({ onUserAction })}
              bordered={false}
              pagination={paginationFactory({
                sizePerPage: 10,
                sizePerPageList: [5, 10, 25, 50, 75, 100],
              })}
              defaultSorted={[
                {
                  dataField: "channel_vch",
                  order: "asc",
                },
              ]}
              rowClasses={(user) => (user._id === selected._id ? "table-info" : null)}
            />
          </CardBody>
        </Card>

        {filtered_whitelist.length > 5 && <AddWhitelistRecord className="d-lg-none" />}
      </Container>
    );
  }
}

Whitelist.propTypes = {
  errors: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  whitelist: PropTypes.array.isRequired,
  selected: PropTypes.object.isRequired,
  internal_user: PropTypes.bool.isRequired,

  // APIs
  getWhitelist: PropTypes.func.isRequired,
  selectWhitelist: PropTypes.func.isRequired,
  createWhitelist: PropTypes.func.isRequired,
  updateWhitelist: PropTypes.func.isRequired,
  deleteWhitelist: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.admin.errors,
  loading: state.admin.loading.whitelist,
  whitelist: state.admin.whitelist,
  selected: state.admin.selectedWhitelist,
  internal_user: state.admin.whitelistInternal,
});

export default connect(mapStateToProps, {
  getWhitelist,
  createWhitelist,
  selectWhitelist,
  updateWhitelist,
  deleteWhitelist,
})(Whitelist);
